import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useFirmwareReleaseNotesStore = defineStore('firmwareReleaseNotes', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getFirmwareReleaseNotes: (state) => state.data?.data,
  },
  actions: {
    async indexFirmwareReleaseNotes(params = {}) {
      try {
        const response = await axios.get('firmware-release-notes', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createFirmwareReleaseNote(params = {}) {
      try {
        const response = await axios.get('firmware-release-notes/create', {params});
        return useCreateForm(`firmware-release-notes`, {...response.data, file: null});
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showFirmwareReleaseNote(firmwareReleaseNoteId, params = {}) {
      try {
        const response = await axios.get(`firmware-release-notes/${ firmwareReleaseNoteId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editFirmwareReleaseNote(firmwareReleaseNoteId, params = {}) {
      try {
        const response = await axios.get(`firmware-release-notes/${ firmwareReleaseNoteId }/edit`, {params});
        return useEditForm(`firmware-release-notes/${ firmwareReleaseNoteId }`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteFirmwareReleaseNote(firmwareReleaseNoteId, params = {}) {
      try {
        const response = await axios.delete(`firmware-release-notes/${ firmwareReleaseNoteId }`, {params});
        toasteventbus.emit('add', {
          summary: 'Firmware Release Note Deleted',
          detail: `Firmware Release Note has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
